<template>
  <div class="container-mapas">
    <div class="left-box">
      <div class="title-section">
        <h2>Sul</h2>
      </div>
      <div>
          <!-- <p class="texto-apoio">assim como os estados da região Sul, Paraná, Santa Catarina e Rio Grande do Sul.</p> -->
          <div class="downloand">
              <ul>
								  <li>
                      <p>Fichas da Região</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Sul.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Paraná - PR</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Parana.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Rio Grande do Sul - RS</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Rio Grande do Sul.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Santa Catarina - SC</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Santa_Catarina.zip" target="_blank">Download</a>
                  </li>
              </ul>
          </div>
          <div class="interacao-intervencao">
			<svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22">
    			<path fill="#7E7E7E" fill-rule="evenodd" d="M13.278 12.965l-5.436-.492-.008-6.237C7.834 5.8 7.464 5 6.57 5c-.695 0-1.264.554-1.264 1.236V16.74l-1.049-1.473a1.255 1.255 0 0 0-1.894-.162 1.206 1.206 0 0 0-.141 1.559L4.94 21.62c.235.335.623.38 1.037.38h6.086c1.201 0 2.234-.678 2.47-1.832l.418-4.45c.249-1.223-.469-2.359-1.673-2.753M1.3 9C.582 9 0 8.464 0 7.8V6.3c0-8.4 13-8.4 13 0v1.5c0 .664-.582 1.2-1.3 1.2-.718 0-1.3-.536-1.3-1.2V6.3c0-4.8-7.8-4.8-7.8 0v1.5c0 .664-.582 1.2-1.3 1.2"/>
			</svg>
			<p>Explore o mapa e tenha acesso aos detalhes e à ficha-modelo de cada intervenção.</p>
		  </div>
      </div>
    </div>
    <div class="right-box">
      <div class="mapa">
				 <Modal />
         <SvgPanZoom :dblClickZoomEnabled="false" :zoomEnabled="true" :controlIconsEnabled="true" :fit="false" :center="true" :contain="true">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1076 1068" style="enable-background:new 0 0 1076 1068;" xml:space="preserve">
<polygon class="st0" points="784.2,381.4 766.7,433.8 766.7,433.8 783.5,381.1 "/>
<polygon class="st0" points="783.5,381.1 766.7,433.8 766.7,433.8 765.6,437 758,436.9 758.7,432 758.8,431.6 759.7,428.8
	759.7,428.8 774,386 773.4,385.7 775.9,377.8 "/>
<path class="st0" d="M775.9,377.8l-2.5,7.9l-67.3-29L679,278.1c-9.3-0.9-41.5-4-73.6-7.5c-22.2-2.4-40-4.5-52.9-6.2
	c-7.7-1-13.7-2-17.9-2.8c-2.2-0.4-3.9-0.8-5.2-1.2l2.1-2.6l0,0l3.3-4.2l0.1-0.2c20.1,4,97.9,12.2,147.4,16.8l2.6,0.2l27.6,80.1
	L775.9,377.8z"/>
<polygon class="st0" points="774,386 759.7,428.8 759.7,428.8 773.4,385.7 "/>
<path class="st1" d="M773.4,385.7l-13.7,43.1l-100.9-1.4l-47.6,35.3l-117.9-20.1l-37.7-20.1l18.4-91.8l55.5-70.3
	c1.4,0.4,3.1,0.8,5.2,1.2c4.2,0.8,10.2,1.7,17.9,2.8c12.9,1.8,30.7,3.9,52.9,6.2c32.1,3.5,64.3,6.6,73.6,7.5l27.1,78.5L773.4,385.7z
	"/>
<polygon class="st0" points="765.6,437 766.7,433.8 752.9,544 696.8,610.8 695.6,609.9 694,601.4 745.1,540.6 758,436.9 "/>
<path class="st0" d="M759.7,428.8l-0.9,2.9l-0.1,0.4l-0.6,4.9l-96.6-1.3l-48.1,35.8l-120.2-20.5l1.5-1.2l4.7-3.9l-6-3.2l117.9,20.1
	l47.6-35.3L759.7,428.8z"/>
<path class="st1" d="M758,436.9l-12.9,103.6L694,601.4l-8.4-44.3L510,484.6l-83,22.2c32.4-27.6,59.7-50.5,66.2-55.9l120.2,20.5
	l48.1-35.8L758,436.9z"/>
<polygon class="st0" points="694,601.4 695.6,609.9 687.5,611.4 687.2,609.5 688.4,608 "/>
<path class="st0" d="M685.6,557.1l8.4,44.3l-5.6,6.7l-1.2,1.5l-8.8-46.5l-168.9-69.7l-95.7,25.6l-0.1-0.6c4.5-3.9,9-7.7,13.4-11.5
	l83-22.2L685.6,557.1z"/>
<path class="st1" d="M507.9,765.8c-8-5.2-186.7-121.9-213.5-138c2.4-3.3,9.8-11.8,32.1-32.5c17-15.8,40.3-36.5,69.2-61.5
	c6-5.2,12-10.4,17.9-15.5l0.1,0.6l95.7-25.6L678.4,563l8.8,46.5L565.5,758.3l-64.6,67l9.3-58.1L507.9,765.8z"/>
<path class="st0" d="M529.4,260.5l-56.1,71l-2-1.6l-4.5-3.5l58.1-73.6c-1,1.2-1.2,2.9-0.6,4.4C525.2,258.8,526.5,259.7,529.4,260.5z
	"/>
<path class="st0" d="M499.3,445.8l-4.7,3.9l-1.5,1.2l-1.9-0.3l1.4-8.1l0.6,0.1L499.3,445.8z"/>
<path class="st0" d="M411.6,511l15.4-4.1c-4.4,3.8-8.9,7.6-13.4,11.5L411.6,511z"/>
<path class="st0" d="M387.4,530.1c7.8-6.8,15.7-13.6,23.4-20.2l0.9,1l2,7.4c-5.9,5.1-11.9,10.2-17.9,15.5
	c-28.9,25-52.2,45.7-69.2,61.5c-22.3,20.7-29.7,29.1-32.1,32.5c26.9,16.1,205.6,132.8,213.5,138l2.2,1.5l-9.3,58.1l64.7-67
	l121.7-148.7l0.4,1.9l8.1-1.5l1.1,1l-2,2.4L571.6,763.8l-0.1,0.1l-82.9,86l12.6-78.6c-71.4-46.7-205-133.6-213.4-137.8
	c-1.5-0.7-2.5-2.2-2.6-3.8C284.7,625.7,284,619.7,387.4,530.1z"/>
<path class="st0" d="M468.1,324.9l-1.2,1.6l6.4,5.1l0.6-0.8l-18.4,91.8l37.7,20.1l-0.6-0.1l-1.4,8.1l1.9,0.3
	c-6.5,5.4-33.8,28.3-66.2,55.9l-15.4,4.1l-0.9-1c33-28.3,62.8-53.3,73.9-62.6l-38.3-20.4l18.8-93.8"/>
<polygon class="st0" points="534.8,253.6 525,252.8 520.1,259 527.5,262.9 "/>
<g @click="mostarIntervencao(1)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(1)">
	<circle class="st2" cx="464" cy="662.3" r="14.5"/>
	<circle class="st3" cx="464" cy="662.3" r="13"/>
	<circle class="st4" cx="464" cy="662.3" r="11.7"/>
	<path class="st5" d="M464,674.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C476.4,669.2,470.8,674.8,464,674.8z M464,651.3c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C475,656.2,470.1,651.3,464,651.3L464,651.3z"/>
	<g>
		<path class="st6" d="M463.3,658.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C463.5,658.3,463.4,658.2,463.3,658.2z"/>
		<path class="st6" d="M463.3,657.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C463.5,657.3,463.4,657.2,463.3,657.2z"/>
		<path class="st6" d="M456.3,668.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C456.4,668.3,456.4,668.3,456.3,668.3z"/>
		<path class="st6" d="M456.2,659.2c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C456,659,456.1,659.1,456.2,659.2z"/>
		<path class="st6" d="M456.3,659.2C456.3,659.2,456.2,659.2,456.3,659.2C456.2,659.2,456.2,659.2,456.3,659.2L456.3,659.2z"/>
		<path class="st6" d="M456.3,661.3C456.3,661.3,456.3,661.2,456.3,661.3c-0.1,0-0.1,0-0.1,0L456.3,661.3z"/>
		<path class="st6" d="M461.1,660c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C461.2,660.3,461.2,660.1,461.1,660C461.1,660,461.1,660,461.1,660z"/>
		<path class="st6" d="M461.1,662c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2s0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C461.3,662.4,461.3,662.2,461.1,662C461.1,662,461.1,662,461.1,662z"/>
		<path class="st6" d="M461.1,664c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C461.2,664,461.1,664,461.1,664z"/>
		<path class="st6" d="M460.6,666.1C460.6,666.1,460.6,666.1,460.6,666.1c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C460.9,665.9,460.7,665.9,460.6,666.1z"/>
		<path class="st6" d="M468.1,666.8c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C467.7,667.2,467.9,667,468.1,666.8z M462.9,668.3h-0.7v-1h0.7V668.3z M463.6,668.3v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7h-0.7
			v-10.4h2.4l2.2,12H463.6z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(2)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(2)">
	<circle class="st2" cx="438.4" cy="683.7" r="14.5"/>
	<circle class="st3" cx="438.4" cy="683.7" r="13"/>
	<circle class="st4" cx="438.4" cy="683.7" r="11.7"/>
	<path class="st5" d="M438.4,696.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C450.8,690.6,445.2,696.1,438.4,696.1z M438.4,672.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C449.5,677.6,444.5,672.6,438.4,672.7L438.4,672.7z"/>
	<g>
		<path class="st6" d="M437.7,679.6c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C437.9,679.7,437.8,679.6,437.7,679.6z"/>
		<path class="st6" d="M437.7,678.6c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C437.9,678.7,437.8,678.6,437.7,678.6z"/>
		<path class="st6" d="M430.7,689.6c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C430.9,689.7,430.8,689.6,430.7,689.6z"/>
		<path class="st6" d="M430.6,680.6c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C430.4,680.4,430.5,680.5,430.6,680.6z"/>
		<path class="st6" d="M430.7,680.6C430.7,680.6,430.6,680.6,430.7,680.6C430.6,680.6,430.6,680.6,430.7,680.6L430.7,680.6z"/>
		<path class="st6" d="M430.8,682.6C430.7,682.6,430.7,682.6,430.8,682.6c-0.1,0-0.1,0-0.1,0L430.8,682.6z"/>
		<path class="st6" d="M435.5,681.4c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C435.7,681.7,435.6,681.5,435.5,681.4C435.5,681.4,435.5,681.4,435.5,681.4z"/>
		<path class="st6" d="M435.5,683.4c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C435.8,683.7,435.7,683.5,435.5,683.4C435.6,683.4,435.5,683.4,435.5,683.4z"/>
		<path class="st6" d="M435.5,685.4c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C435.6,685.4,435.6,685.4,435.5,685.4z"/>
		<path class="st6" d="M435,687.5C435,687.5,435,687.5,435,687.5c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h-0.3h0
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C435.3,687.3,435.1,687.3,435,687.5z"/>
		<path class="st6" d="M442.5,688.2c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C442.2,688.6,442.4,688.4,442.5,688.2z M437.4,689.6h-0.7v-1h0.7V689.6z M438,689.6v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H438z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(3)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(3)">
	<circle class="st2" cx="469.6" cy="720" r="14.5"/>
	<circle class="st3" cx="469.6" cy="720" r="13"/>
	<circle class="st4" cx="469.6" cy="720" r="11.7"/>
	<path class="st5" d="M469.7,732.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C482.1,726.9,476.5,732.4,469.7,732.4z M469.7,709c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C480.7,713.9,475.8,709,469.7,709L469.7,709z"/>
	<g>
		<path class="st6" d="M469,715.9c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C469.2,716,469.1,715.9,469,715.9z"/>
		<path class="st6" d="M469,714.9c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C469.2,715,469.1,714.9,469,714.9z"/>
		<path class="st6" d="M462,725.9c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C462.1,726,462.1,726,462,725.9z"/>
		<path class="st6" d="M461.9,716.9c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C461.7,716.7,461.8,716.8,461.9,716.9z"/>
		<path class="st6" d="M462,716.9C461.9,716.9,461.9,716.9,462,716.9C461.9,716.9,461.9,716.9,462,716.9L462,716.9z"/>
		<path class="st6" d="M462,718.9C462,718.9,462,718.9,462,718.9c-0.1,0-0.1,0-0.1,0L462,718.9z"/>
		<path class="st6" d="M466.8,717.7c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C466.9,718,466.9,717.8,466.8,717.7C466.8,717.7,466.8,717.7,466.8,717.7z"/>
		<path class="st6" d="M466.8,719.7c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C467,720,467,719.8,466.8,719.7C466.8,719.7,466.8,719.7,466.8,719.7z"/>
		<path class="st6" d="M466.8,721.7c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C466.9,721.7,466.8,721.7,466.8,721.7z"/>
		<path class="st6" d="M466.3,723.8C466.3,723.8,466.3,723.8,466.3,723.8c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C466.6,723.6,466.4,723.6,466.3,723.8z"/>
		<path class="st6" d="M473.8,724.5c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0V726h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.2-0.3-0.3-0.3
			h-3.7l-0.2-1C473.4,724.9,473.6,724.7,473.8,724.5z M468.6,725.9H468v-1h0.7V725.9z M469.3,725.9v-1h2c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7H468v-10.4h2.4l2.2,12
			H469.3z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(4)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(4)">
	<circle class="st2" cx="717.1" cy="494.3" r="14.5"/>
	<circle class="st3" cx="717.1" cy="494.3" r="13"/>
	<circle class="st4" cx="717.1" cy="494.3" r="11.7"/>
	<path class="st5" d="M717.1,506.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C729.6,501.1,724,506.7,717.1,506.7z M717.1,483.2c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C728.2,488.2,723.3,483.2,717.1,483.2L717.1,483.2z"/>
	<g>
		<path class="st6" d="M716.5,490.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C716.6,490.2,716.6,490.2,716.5,490.2z"/>
		<path class="st6" d="M716.5,489.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C716.6,489.2,716.6,489.2,716.5,489.2z"/>
		<path class="st6" d="M709.5,500.2c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C709.6,500.2,709.5,500.2,709.5,500.2z"/>
		<path class="st6" d="M709.4,491.1c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C709.2,490.9,709.3,491.1,709.4,491.1z"/>
		<path class="st6" d="M709.5,491.2C709.4,491.2,709.4,491.2,709.5,491.2C709.4,491.1,709.4,491.1,709.5,491.2L709.5,491.2z"/>
		<path class="st6" d="M709.5,493.2C709.5,493.2,709.5,493.2,709.5,493.2c-0.1,0-0.1,0-0.1,0L709.5,493.2z"/>
		<path class="st6" d="M714.2,491.9c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C714.4,492.2,714.4,492,714.2,491.9C714.2,491.9,714.2,491.9,714.2,491.9z"/>
		<path class="st6" d="M714.2,493.9c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C714.5,494.3,714.5,494.1,714.2,493.9C714.3,494,714.3,494,714.2,493.9z"/>
		<path class="st6" d="M714.2,496c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1h-0.2h0
			c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C714.4,496,714.3,496,714.2,496z"/>
		<path class="st6" d="M713.8,498C713.8,498,713.8,498,713.8,498c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h-0.3h0
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C714.1,497.8,713.9,497.9,713.8,498z"/>
		<path class="st6" d="M721.3,498.8c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0H723l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C720.9,499.2,721.1,499,721.3,498.8z M716.1,500.2h-0.7v-1h0.7V500.2z M716.8,500.2v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7v-10.4h2.4l2.2,12H716.8z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(5)">
		<v-touch tag="a" v-on:tap="mostarIntervencao(5)">
	<circle class="st2" cx="715.5" cy="399.1" r="14.5"/>
	<circle class="st3" cx="715.5" cy="399.1" r="13"/>
	<circle class="st4" cx="715.5" cy="399.1" r="11.7"/>
	<path class="st5" d="M715.5,411.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C727.9,405.9,722.3,411.5,715.5,411.5z M715.5,388c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1c0,0,0,0,0,0
		C726.5,392.9,721.6,388,715.5,388L715.5,388z"/>
	<g>
		<path class="st6" d="M714.8,395c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C715,395,714.9,395,714.8,395z"/>
		<path class="st6" d="M714.8,394c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C715,394,714.9,394,714.8,394z"/>
		<path class="st6" d="M707.8,405c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3
			c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2C707.9,405,707.9,405,707.8,405z"/>
		<path class="st6" d="M707.7,395.9c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1v0h0h0h-0.2h0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2C707.5,395.7,707.6,395.8,707.7,395.9z"/>
		<path class="st6" d="M707.8,396C707.7,395.9,707.7,395.9,707.8,396C707.7,395.9,707.7,395.9,707.8,396L707.8,396z"/>
		<path class="st6" d="M707.8,398C707.8,398,707.8,398,707.8,398c-0.1,0-0.1,0-0.1,0L707.8,398z"/>
		<path class="st6" d="M712.6,396.7c-0.1-0.1-0.3-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0
			h-0.3l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C712.7,397,712.7,396.8,712.6,396.7C712.6,396.7,712.6,396.7,712.6,396.7z"/>
		<path class="st6" d="M712.6,398.7c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.5l0-0.1l-0.1,0h-0.3
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C712.8,399.1,712.8,398.9,712.6,398.7C712.6,398.7,712.6,398.7,712.6,398.7z"/>
		<path class="st6" d="M712.6,400.7c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.2h0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C712.7,400.8,712.6,400.7,712.6,400.7z"/>
		<path class="st6" d="M712.1,402.8C712.1,402.8,712.1,402.8,712.1,402.8c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.5l0-0.1
			h-0.3h0l-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1C712.4,402.6,712.2,402.6,712.1,402.8z"/>
		<path class="st6" d="M719.6,403.6c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.3,0.3-0.5,0.5-0.7,0.5
			c-0.2,0-0.4-0.3-0.5-0.5l0-0.1h0h-0.3l-0.1,0h0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3
			c0,0,0,0,0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0
			c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C719.2,403.9,719.4,403.8,719.6,403.6z M714.4,405h-0.7v-1h0.7V405z M715.1,405v-1h2
			c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0.1,0,0.1v7
			h-0.7V393h2.4l2.2,12H715.1z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(6)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(6)">
	<circle class="st2" cx="744.1" cy="479.1" r="14.5"/>
	<circle class="st3" cx="744.1" cy="479.1" r="13"/>
	<circle class="st4" cx="744.1" cy="479.1" r="11.7"/>
	<path class="st5" d="M744.1,491.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C756.5,485.9,750.9,491.5,744.1,491.5z M744.1,468c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C755.1,473,750.2,468,744.1,468L744.1,468z"/>
	<path class="st6" d="M751.6,478.7h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H747v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C751.9,478.8,751.8,478.7,751.6,478.7
		C751.6,478.7,751.6,478.7,751.6,478.7z M744.5,474.9h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9L744.5,474.9z M738.2,484.1h-1.4v-4.9h1.4V484.1z M743.4,474h0.6v0.3h-0.6V474z M743.4,474.8h0.6v0.6
		h-0.6V474.8z M743.4,475.9h0.6v1.7h-0.6V475.9z M742.1,475.4L742.1,475.4l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L742.1,475.4z M742.4,478.1h2.8v1.1h-2.8V478.1z M738.7,480.2h1.8v2.8
		h-1.8V480.2z M746.5,483.6H741v-3.9h5.5V483.6z M749.5,483H747v-2.8h2.5V483z M751.4,484.1H750v-4.9h1.4L751.4,484.1z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(7)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(7)">
	<circle class="st2" cx="748.3" cy="449.4" r="14.5"/>
	<circle class="st3" cx="748.3" cy="449.4" r="13"/>
	<circle class="st4" cx="748.3" cy="449.4" r="11.7"/>
	<path class="st5" d="M748.3,461.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C760.7,456.3,755.1,461.8,748.3,461.8z M748.3,438.3c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C759.3,443.3,754.4,438.4,748.3,438.3L748.3,438.3z"/>
	<path class="st6" d="M755.8,449h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C756.1,449.1,755.9,449,755.8,449
		C755.8,449,755.8,449,755.8,449z M748.7,445.2h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0
		h-0.1h-0.1l-1.7-0.3h-0.9L748.7,445.2z M742.3,454.4h-1.4v-4.9h1.4V454.4z M747.6,444.4h0.6v0.3h-0.6V444.4z M747.6,445.2h0.6v0.6
		h-0.6V445.2z M747.6,446.3h0.6v1.7h-0.6V446.3z M746.3,445.8L746.3,445.8l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L746.3,445.8z M746.5,448.4h2.8v1.1h-2.8V448.4z M742.8,450.6h1.8v2.8
		h-1.8V450.6z M750.7,453.9h-5.5v-3.9h5.5V453.9z M753.7,453.4h-2.5v-2.8h2.5V453.4z M755.6,454.4h-1.4v-4.9h1.4L755.6,454.4z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(8)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(8)">
	<circle class="st2" cx="626.4" cy="591.9" r="14.5"/>
	<circle class="st3" cx="626.4" cy="591.9" r="13"/>
	<circle class="st4" cx="626.4" cy="591.9" r="11.7"/>
	<path class="st5" d="M626.4,604.3c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C638.8,598.7,633.3,604.3,626.4,604.3z M626.4,580.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C637.5,585.8,632.5,580.8,626.4,580.8L626.4,580.8z"/>
	<path class="st6" d="M634,591.5H632c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0v1.4h-1.1
		c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3H621v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3
		h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8
		c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C634.2,591.6,634.1,591.5,634,591.5C634,591.5,634,591.5,634,591.5z
		 M626.9,587.6h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5s-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9V587.6z
		 M620.5,596.9h-1.4V592h1.4V596.9z M625.8,586.8h0.6v0.3h-0.6V586.8z M625.8,587.6h0.6v0.6h-0.6V587.6z M625.8,588.7h0.6v1.7h-0.6
		V588.7z M624.5,588.2L624.5,588.2l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6
		L624.5,588.2z M624.7,590.9h2.8v1.1h-2.8V590.9z M621,593h1.8v2.8H621V593z M628.8,596.4h-5.5v-3.9h5.5V596.4z M631.8,595.8h-2.5
		V593h2.5V595.8z M633.7,596.9h-1.4V592h1.4L633.7,596.9z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(9)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(9)">
	<circle class="st2" cx="545.6" cy="747" r="14.5"/>
	<circle class="st3" cx="545.6" cy="747" r="13"/>
	<circle class="st4" cx="545.6" cy="747" r="11.7"/>
	<path class="st5" d="M545.6,759.4c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C558.1,753.8,552.5,759.4,545.6,759.4z M545.6,735.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C556.7,740.8,551.8,735.9,545.6,735.9L545.6,735.9z"/>
	<path class="st6" d="M553.2,746.6h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C553.4,746.7,553.3,746.6,553.2,746.6
		C553.2,746.6,553.2,746.6,553.2,746.6z M546.1,742.7h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5s-0.2,0.7-0.5,0.8l0,0h-0.1
		h-0.1l-1.7-0.3h-0.9V742.7z M539.7,752h-1.4V747h1.4V752z M545,741.9h0.6v0.3H545V741.9z M545,742.7h0.6v0.6H545V742.7z M545,743.8
		h0.6v1.7H545V743.8z M543.7,743.3L543.7,743.3l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0
		l1.7,0.3h0.9v0.6L543.7,743.3z M543.9,746h2.8v1.1h-2.8V746z M540.2,748.1h1.8v2.8h-1.8V748.1z M548.1,751.5h-5.5v-3.9h5.5V751.5z
		 M551.1,750.9h-2.5v-2.8h2.5V750.9z M553,752h-1.4V747h1.4L553,752z"/>
	</v-touch>
</g>
<g  @click="mostarIntervencao(10)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(10)">
	<circle class="st2" cx="470.3" cy="417.6" r="14.5"/>
	<circle class="st3" cx="470.3" cy="417.6" r="13"/>
	<circle class="st4" cx="470.3" cy="417.6" r="11.7"/>
	<path class="st5" d="M470.3,430c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C482.7,424.5,477.2,430,470.3,430z M470.3,406.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C481.4,411.5,476.4,406.6,470.3,406.6L470.3,406.6z"/>
	<path class="st6" d="M477.9,417.2h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5V418c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4H467c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C478.1,417.3,478,417.2,477.9,417.2
		C477.9,417.2,477.9,417.2,477.9,417.2z M470.8,413.4h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9L470.8,413.4z M464.4,422.7H463v-4.9h1.4V422.7z M469.7,412.6h0.6v0.3h-0.6V412.6z M469.7,413.4h0.6
		v0.6h-0.6V413.4z M469.7,414.5h0.6v1.7h-0.6V414.5z M468.3,414L468.3,414l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L468.3,414z M468.6,416.6h2.8v1.1h-2.8V416.6z M464.9,418.8h1.8v2.8h-1.8
		V418.8z M472.7,422.1h-5.5v-3.9h5.5V422.1z M475.7,421.6h-2.5v-2.8h2.5V421.6z M477.6,422.7h-1.4v-4.9h1.4L477.6,422.7z"/>
	</v-touch>
</g>
<g  @click="mostarIntervencao(11)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(11)">
	<circle class="st2" cx="509.8" cy="404.6" r="14.5"/>
	<circle class="st3" cx="509.8" cy="404.6" r="13"/>
	<circle class="st4" cx="509.8" cy="404.6" r="11.7"/>
	<path class="st5" d="M509.8,417c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C522.2,411.5,516.6,417,509.8,417z M509.8,393.5c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C520.9,398.5,515.9,393.5,509.8,393.5L509.8,393.5z"/>
	<path class="st6" d="M517.3,404.2h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5V405c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3V409h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C517.6,404.3,517.5,404.2,517.3,404.2
		C517.3,404.2,517.3,404.2,517.3,404.2z M510.2,400.4h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9L510.2,400.4z M503.9,409.6h-1.4v-4.9h1.4V409.6z M509.2,399.5h0.6v0.3h-0.6V399.5z M509.2,400.4h0.6
		v0.6h-0.6V400.4z M509.2,401.4h0.6v1.7h-0.6V401.4z M507.8,400.9L507.8,400.9l-1.7,0.3H506c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L507.8,400.9z M508.1,403.6h2.8v1.1h-2.8V403.6z M504.4,405.8h1.8v2.8
		h-1.8V405.8z M512.2,409.1h-5.5v-3.9h5.5V409.1z M515.2,408.5h-2.5v-2.8h2.5V408.5z M517.1,409.6h-1.4v-4.9h1.4L517.1,409.6z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(12)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(12)">
	<circle class="st2" cx="592.1" cy="625.9" r="14.5"/>
	<circle class="st3" cx="592.1" cy="625.9" r="13"/>
	<circle class="st4" cx="592.1" cy="625.9" r="11.7"/>
	<path class="st5" d="M592.1,638.3c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C604.6,632.8,599,638.3,592.1,638.3z M592.1,614.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C603.2,619.8,598.3,614.8,592.1,614.8L592.1,614.8z"/>
	<path class="st6" d="M599.7,625.5h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H595v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C599.9,625.6,599.8,625.5,599.7,625.5
		C599.7,625.5,599.7,625.5,599.7,625.5z M592.6,621.7h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5s-0.2,0.7-0.5,0.8l0,0h-0.1
		h-0.1l-1.7-0.3h-0.9L592.6,621.7z M586.2,630.9h-1.4V626h1.4V630.9z M591.5,620.8h0.6v0.3h-0.6V620.8z M591.5,621.7h0.6v0.6h-0.6
		V621.7z M591.5,622.7h0.6v1.7h-0.6V622.7z M590.2,622.3L590.2,622.3l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6
		c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L590.2,622.3z M590.4,624.9h2.8v1.1h-2.8V624.9z M586.7,627.1h1.8v2.8h-1.8V627.1z M594.6,630.4
		h-5.5v-3.9h5.5V630.4z M597.6,629.8h-2.5v-2.8h2.5V629.8z M599.5,630.9h-1.4V626h1.4L599.5,630.9z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(13)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(13)">
	<circle class="st2" cx="602.3" cy="656.8" r="14.5"/>
	<circle class="st3" cx="602.3" cy="656.8" r="13"/>
	<circle class="st4" cx="602.3" cy="656.8" r="11.7"/>
	<path class="st5" d="M602.3,669.2c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C614.7,663.7,609.1,669.2,602.3,669.2z M602.3,645.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C613.3,650.7,608.4,645.7,602.3,645.7L602.3,645.7z"/>
	<path class="st6" d="M609.8,656.4h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C610.1,656.5,610,656.4,609.8,656.4
		C609.8,656.4,609.8,656.4,609.8,656.4z M602.7,652.6h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5s-0.2,0.7-0.5,0.8l0,0h-0.1
		h-0.1l-1.7-0.3h-0.9L602.7,652.6z M596.3,661.8h-1.4v-4.9h1.4V661.8z M601.6,651.7h0.6v0.3h-0.6V651.7z M601.6,652.5h0.6v0.6h-0.6
		V652.5z M601.6,653.6h0.6v1.7h-0.6V653.6z M600.3,653.1L600.3,653.1l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6
		c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L600.3,653.1z M600.5,655.8h2.8v1.1h-2.8V655.8z M596.8,658h1.8v2.8h-1.8V658z M604.7,661.3
		h-5.5v-3.9h5.5V661.3z M607.7,660.7h-2.5V658h2.5V660.7z M609.6,661.8h-1.4v-4.9h1.4L609.6,661.8z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(14)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(14)">
	<circle class="st2" cx="745.2" cy="507.3" r="14.5"/>
	<circle class="st3" cx="745.2" cy="507.3" r="13"/>
	<circle class="st4" cx="745.2" cy="507.3" r="11.7"/>
	<path class="st5" d="M745.2,519.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C757.6,514.2,752,519.7,745.2,519.7z M745.2,496.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
		C756.2,501.2,751.3,496.2,745.2,496.2L745.2,496.2z"/>
	<path class="st6" d="M752.7,506.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H748v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0
		l-1.6,0.3h-0.8V502c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0v0.6h-0.8l-1.6-0.3
		c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0
		v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4
		c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5
		v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C753,507,752.8,506.9,752.7,506.9
		C752.7,506.9,752.7,506.9,752.7,506.9z M745.6,503.1h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8
		l0,0h-0.1h-0.1l-1.7-0.3h-0.9V503.1z M739.2,512.3h-1.4v-4.9h1.4V512.3z M744.5,502.2h0.6v0.3h-0.6V502.2z M744.5,503.1h0.6v0.6
		h-0.6V503.1z M744.5,504.1h0.6v1.7h-0.6V504.1z M743.2,503.7L743.2,503.7l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L743.2,503.7z M743.4,506.3h2.8v1.1h-2.8V506.3z M739.7,508.5h1.8v2.8
		h-1.8V508.5z M747.6,511.8h-5.5V508h5.5V511.8z M750.6,511.2h-2.5v-2.8h2.5V511.2z M752.5,512.3h-1.4v-4.9h1.4L752.5,512.3z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(15)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(15)">
	<circle class="st2" cx="600" cy="286.1" r="14.5"/>
	<circle class="st3" cx="600" cy="286.1" r="13"/>
	<circle class="st4" cx="600" cy="286.1" r="11.7"/>
	<path class="st5" d="M600,298.5c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C612.4,292.9,606.8,298.5,600,298.5z M600,275c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1c0,0,0,0,0,0
		C611.1,280,606.1,275,600,275L600,275z"/>
	<polygon class="st6" points="600,286.1 600,286.1 600,286.1 	"/>
	<g>
		<g>
			<g>
				<path d="M604,281h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9c-0.2,0-0.4,0.1-0.4,0.3
					v0.6H596c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C605.3,281.6,604.7,281,604,281z
					 M597.9,280.8h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					V280.8z M604.7,291.7c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L604.7,291.7L604.7,291.7z"/>
				<path d="M598.7,286.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C598.9,286.9,598.9,286.7,598.7,286.5
					C598.7,286.5,598.7,286.5,598.7,286.5z"/>
				<path d="M603.4,287.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C603.7,287.4,603.6,287.2,603.4,287.2z"/>
				<path d="M598.7,283.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C598.9,284.2,598.9,284,598.7,283.9C598.7,283.9,598.7,283.9,598.7,283.9z
					"/>
				<path d="M603.4,284.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C603.7,284.7,603.6,284.6,603.4,284.6z"/>
				<path d="M598.7,289.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C598.9,289.5,598.9,289.3,598.7,289.1
					C598.7,289.1,598.7,289.1,598.7,289.1z"/>
				<path d="M603.4,289.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C603.7,290,603.6,289.8,603.4,289.8z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(16)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(16)">
	<circle class="st2" cx="597.5" cy="324.9" r="14.5"/>
	<circle class="st3" cx="597.5" cy="324.9" r="13"/>
	<circle class="st4" cx="597.5" cy="324.9" r="11.7"/>
	<path class="st5" d="M597.5,337.3c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C609.9,331.7,604.4,337.3,597.5,337.3z M597.5,313.8c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C608.6,318.8,603.7,313.8,597.5,313.8L597.5,313.8z"/>
	<polygon class="st6" points="597.5,324.9 597.5,324.9 597.5,324.9 	"/>
	<g>
		<g>
			<g>
				<path d="M601.5,319.8h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C602.9,320.4,602.3,319.8,601.5,319.8z M595.4,319.7h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V319.7z M602.3,330.5c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L602.3,330.5
					L602.3,330.5z"/>
				<path d="M596.3,325.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C596.4,325.7,596.4,325.5,596.3,325.3
					C596.3,325.3,596.3,325.3,596.3,325.3z"/>
				<path d="M601,326h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3C601.3,326.2,601.1,326,601,326z
					"/>
				<path d="M596.3,322.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C596.4,323.1,596.4,322.9,596.3,322.7
					C596.3,322.7,596.3,322.7,596.3,322.7z"/>
				<path d="M601,323.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C601.3,323.6,601.1,323.4,601,323.4z"/>
				<path d="M596.3,327.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C596.4,328.3,596.4,328.1,596.3,327.9C596.3,328,596.3,327.9,596.3,327.9z
					"/>
				<path d="M601,328.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S601.1,328.6,601,328.6z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(17)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(17)">
	<circle class="st2" cx="622.8" cy="631.4" r="14.5"/>
	<circle class="st3" cx="622.8" cy="631.4" r="13"/>
	<circle class="st4" cx="622.8" cy="631.4" r="11.7"/>
	<path class="st5" d="M622.8,643.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C635.3,638.3,629.7,643.9,622.8,643.9z M622.8,620.4c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C633.9,625.3,629,620.4,622.8,620.4L622.8,620.4z"/>
	<polygon class="st6" points="622.8,631.4 622.8,631.4 622.8,631.4 	"/>
	<g>
		<g>
			<g>
				<path d="M626.9,626.4h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C628.2,627,627.6,626.4,626.9,626.4z M620.7,626.2h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V626.2z M627.6,637.1c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V627h1.2c0.4,0,0.7,0.3,0.7,0.7L627.6,637.1
					L627.6,637.1z"/>
				<path d="M621.6,631.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C621.7,632.2,621.7,632,621.6,631.9C621.6,631.9,621.6,631.9,621.6,631.9z
					"/>
				<path d="M626.3,632.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S626.4,632.6,626.3,632.6z"/>
				<path d="M621.6,629.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C621.7,629.6,621.7,629.4,621.6,629.3
					C621.6,629.3,621.6,629.3,621.6,629.3z"/>
				<path d="M626.3,630h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S626.4,630,626.3,630z"/>
				<path d="M621.6,634.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C621.7,634.8,621.7,634.6,621.6,634.5
					C621.6,634.5,621.6,634.5,621.6,634.5z"/>
				<path d="M626.3,635.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C626.6,635.3,626.4,635.2,626.3,635.2z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(18)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(18)">
	<circle class="st2" cx="535.1" cy="638.3" r="14.5"/>
	<circle class="st3" cx="535.1" cy="638.3" r="13"/>
	<circle class="st4" cx="535.1" cy="638.3" r="11.7"/>
	<path class="st5" d="M535.1,650.8c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C547.5,645.2,541.9,650.7,535.1,650.8z M535.1,627.3c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1c0,0,0,0,0,0
		C546.1,632.2,541.2,627.3,535.1,627.3L535.1,627.3z"/>
	<polygon class="st6" points="535.1,638.3 535.1,638.3 535.1,638.3 	"/>
	<g>
		<g>
			<g>
				<path d="M539.1,633.3h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C540.4,633.9,539.8,633.3,539.1,633.3z M533,633.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3H533V633.1z M539.8,643.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7V643.9
					L539.8,643.9z"/>
				<path d="M533.8,638.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C533.9,639.1,533.9,638.9,533.8,638.8
					C533.8,638.8,533.8,638.8,533.8,638.8z"/>
				<path d="M538.5,639.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C538.8,639.6,538.7,639.5,538.5,639.5z"/>
				<path d="M533.8,636.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C533.9,636.5,533.9,636.3,533.8,636.2
					C533.8,636.2,533.8,636.2,533.8,636.2z"/>
				<path d="M538.5,636.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S538.7,636.9,538.5,636.9z"/>
				<path d="M533.8,641.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C533.9,641.7,533.9,641.5,533.8,641.4
					C533.8,641.4,533.8,641.4,533.8,641.4z"/>
				<path d="M538.5,642.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C538.8,642.2,538.7,642.1,538.5,642.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(19)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(19)">
	<circle class="st2" cx="371.2" cy="570" r="14.5"/>
	<circle class="st3" cx="371.2" cy="570" r="13"/>
	<circle class="st4" cx="371.2" cy="570" r="11.7"/>
	<path class="st5" d="M371.2,582.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C383.7,576.8,378.1,582.4,371.2,582.4z M371.2,558.9c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1c0,0,0,0,0,0
		C382.3,563.9,377.4,558.9,371.2,558.9L371.2,558.9z"/>
	<polygon class="st6" points="371.2,570 371.2,570 371.2,570 	"/>
	<g>
		<g>
			<g>
				<path d="M375.3,564.9H374v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C376.6,565.5,376,564.9,375.3,564.9z M369.1,564.7h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V564.7z M376,575.6c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L376,575.6
					L376,575.6z"/>
				<path d="M370,570.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C370.1,570.7,370.1,570.6,370,570.4C370,570.4,370,570.4,370,570.4z"/>
				<path d="M374.7,571.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C375,571.3,374.8,571.1,374.7,571.1z"/>
				<path d="M370,567.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C370.1,568.1,370.1,567.9,370,567.8C370,567.8,370,567.8,370,567.8z"/>
				<path d="M374.7,568.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C375,568.6,374.8,568.5,374.7,568.5z"/>
				<path d="M370,573c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C370.1,573.4,370.1,573.2,370,573C370,573,370,573,370,573z"/>
				<path d="M374.7,573.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S374.8,573.7,374.7,573.7z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(20)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(20)">
	<circle class="st2" cx="458.6" cy="492.8" r="14.5"/>
	<circle class="st3" cx="458.6" cy="492.8" r="13"/>
	<circle class="st4" cx="458.6" cy="492.8" r="11.7"/>
	<path class="st5" d="M458.6,505.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C471,499.7,465.4,505.2,458.6,505.2z M458.6,481.7c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C469.6,486.7,464.7,481.7,458.6,481.7L458.6,481.7z"/>
	<polygon class="st6" points="458.6,492.8 458.6,492.8 458.6,492.8 	"/>
	<g>
		<g>
			<g>
				<path d="M462.6,487.7h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C463.9,488.3,463.3,487.8,462.6,487.7z M456.5,487.6h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V487.6z M463.3,498.4c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L463.3,498.4
					L463.3,498.4z"/>
				<path d="M457.3,493.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C457.4,493.6,457.5,493.4,457.3,493.2
					C457.3,493.3,457.3,493.2,457.3,493.2z"/>
				<path d="M462,493.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C462.3,494.1,462.2,493.9,462,493.9z"/>
				<path d="M457.3,490.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C457.4,491,457.5,490.8,457.3,490.6C457.3,490.6,457.3,490.6,457.3,490.6z
					"/>
				<path d="M462,491.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C462.3,491.5,462.2,491.3,462,491.3z"/>
				<path d="M457.3,495.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C457.4,496.2,457.5,496,457.3,495.9C457.3,495.9,457.3,495.9,457.3,495.9z
					"/>
				<path d="M462,496.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C462.3,496.7,462.2,496.6,462,496.6z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(21)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(21)">
	<circle class="st2" cx="548.1" cy="477.6" r="14.5"/>
	<circle class="st3" cx="548.1" cy="477.6" r="13"/>
	<circle class="st4" cx="548.1" cy="477.6" r="11.7"/>
	<path class="st5" d="M548.1,490c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C560.5,484.5,555,490,548.1,490z M548.1,466.5c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1c0,0,0,0,0,0
		C559.2,471.5,554.2,466.5,548.1,466.5L548.1,466.5z"/>
	<polygon class="st6" points="548.1,477.6 548.1,477.6 548.1,477.6 	"/>
	<g>
		<g>
			<g>
				<path d="M552.1,472.5h-1.2V472c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C553.4,473.1,552.8,472.6,552.1,472.5z M546,472.4h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3H546V472.4z M552.8,483.2c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L552.8,483.2
					L552.8,483.2z"/>
				<path d="M546.8,478c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C547,478.4,547,478.2,546.8,478C546.8,478.1,546.8,478.1,546.8,478z"/>
				<path d="M551.5,478.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C551.8,478.9,551.7,478.8,551.5,478.8z"/>
				<path d="M546.8,475.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C547,475.8,547,475.6,546.8,475.4C546.8,475.4,546.8,475.4,546.8,475.4z"
					/>
				<path d="M551.5,476.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C551.8,476.3,551.7,476.1,551.5,476.1z"/>
				<path d="M546.8,480.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C547,481,547,480.8,546.8,480.7C546.8,480.7,546.8,480.7,546.8,480.7z"/>
				<path d="M551.5,481.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C551.8,481.5,551.7,481.4,551.5,481.4z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(22)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(22)">
	<circle class="st2" cx="687.2" cy="406.5" r="14.5"/>
	<circle class="st3" cx="687.2" cy="406.5" r="13"/>
	<circle class="st4" cx="687.2" cy="406.5" r="11.7"/>
	<path class="st5" d="M687.2,419c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C699.6,413.4,694.1,419,687.2,419z M687.2,395.5c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C698.3,400.4,693.3,395.5,687.2,395.5L687.2,395.5z"/>
	<polygon class="st6" points="687.2,406.5 687.2,406.5 687.2,406.5 	"/>
	<g>
		<g>
			<g>
				<path d="M691.2,401.5H690v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C692.5,402.1,691.9,401.5,691.2,401.5z M685.1,401.3h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V401.3z M691.9,412.2c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L691.9,412.2
					L691.9,412.2z"/>
				<path d="M685.9,407c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C686.1,407.3,686.1,407.1,685.9,407C685.9,407,685.9,407,685.9,407z"/>
				<path d="M690.6,407.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C690.9,407.8,690.8,407.7,690.6,407.7z"/>
				<path d="M685.9,404.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C686.1,404.7,686.1,404.5,685.9,404.4
					C685.9,404.4,685.9,404.4,685.9,404.4z"/>
				<path d="M690.6,405.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C690.9,405.2,690.8,405.1,690.6,405.1z"/>
				<path d="M685.9,409.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C686.1,409.9,686.1,409.7,685.9,409.6
					C685.9,409.6,685.9,409.6,685.9,409.6z"/>
				<path d="M690.6,410.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S690.8,410.3,690.6,410.3z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(23)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(23)">
	<circle class="st2" cx="735.2" cy="537.3" r="14.5"/>
	<circle class="st3" cx="735.2" cy="537.3" r="13"/>
	<circle class="st4" cx="735.2" cy="537.3" r="11.7"/>
	<path class="st5" d="M735.2,549.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C747.6,544.2,742.1,549.7,735.2,549.7z M735.2,526.2c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C746.3,531.2,741.4,526.2,735.2,526.2L735.2,526.2z"/>
	<polygon class="st6" points="735.2,537.3 735.2,537.3 735.2,537.3 	"/>
	<g>
		<g>
			<g>
				<path d="M739.2,532.3H738v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C740.6,532.8,740,532.3,739.2,532.3z M733.1,532.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V532.1z M740,542.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7V542.9
					L740,542.9z"/>
				<path d="M734,537.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C734.1,538.1,734.1,537.9,734,537.7C734,537.8,734,537.8,734,537.7z"/>
				<path d="M738.7,538.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C739,538.6,738.8,538.5,738.7,538.5z"/>
				<path d="M734,535.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C734.1,535.5,734.1,535.3,734,535.1C734,535.2,734,535.1,734,535.1z"/>
				<path d="M738.7,535.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C739,536,738.8,535.8,738.7,535.8z"/>
				<path d="M734,540.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C734.1,540.7,734.1,540.5,734,540.4C734,540.4,734,540.4,734,540.4z"/>
				<path d="M738.7,541.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C739,541.2,738.8,541.1,738.7,541.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(24)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(24)">
	<circle class="st2" cx="709.1" cy="563.7" r="14.5"/>
	<circle class="st3" cx="709.1" cy="563.7" r="13"/>
	<circle class="st4" cx="709.1" cy="563.7" r="11.7"/>
	<path class="st5" d="M709.1,576.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C721.5,570.6,716,576.1,709.1,576.1z M709.1,552.6c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C720.2,557.6,715.2,552.6,709.1,552.6L709.1,552.6z"/>
	<polygon class="st6" points="709.1,563.7 709.1,563.7 709.1,563.7 	"/>
	<g>
		<g>
			<g>
				<path d="M713.1,558.7h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2V560
					C714.5,559.2,713.9,558.7,713.1,558.7z M707,558.5h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3H707V558.5z M713.9,569.3c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6V560
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7V569.3
					L713.9,569.3z"/>
				<path d="M707.9,564.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C708,564.5,708,564.3,707.9,564.2C707.9,564.2,707.9,564.2,707.9,564.2z"
					/>
				<path d="M712.5,564.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S712.7,564.9,712.5,564.9z"/>
				<path d="M707.9,561.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C708,561.9,708,561.7,707.9,561.5C707.9,561.6,707.9,561.6,707.9,561.5z"
					/>
				<path d="M712.5,562.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C712.9,562.4,712.7,562.2,712.5,562.2z"/>
				<path d="M707.9,566.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C708,567.1,708,566.9,707.9,566.8C707.9,566.8,707.9,566.8,707.9,566.8z"
					/>
				<path d="M712.5,567.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S712.7,567.5,712.5,567.5z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(25)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(25)">
	<circle class="st2" cx="688.7" cy="505.4" r="14.5"/>
	<circle class="st3" cx="688.7" cy="505.4" r="13"/>
	<circle class="st4" cx="688.7" cy="505.4" r="11.7"/>
	<path class="st5" d="M688.7,517.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4c0,0,0,0,0,0
		C701.2,512.2,695.6,517.8,688.7,517.8z M688.7,494.3c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
		c0,0,0,0,0,0C699.8,499.2,694.9,494.3,688.7,494.3L688.7,494.3z"/>
	<polygon class="st6" points="688.7,505.4 688.7,505.4 688.7,505.4 	"/>
	<g>
		<g>
			<g>
				<path d="M692.8,500.3h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C694.1,500.9,693.5,500.3,692.8,500.3z M686.6,500.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7c0.4,0,0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2V500.1z M693.5,511c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V501h1.2c0.4,0,0.7,0.3,0.7,0.7V511L693.5,511z
					"/>
				<path d="M687.5,505.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C687.6,506.1,687.6,505.9,687.5,505.8
					C687.5,505.8,687.5,505.8,687.5,505.8z"/>
				<path d="M692.2,506.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C692.5,506.6,692.3,506.5,692.2,506.5z"/>
				<path d="M687.5,503.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C687.6,503.5,687.6,503.3,687.5,503.2
					C687.5,503.2,687.5,503.2,687.5,503.2z"/>
				<path d="M692.2,503.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C692.5,504,692.3,503.9,692.2,503.9z"/>
				<path d="M687.5,508.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C687.6,508.8,687.6,508.6,687.5,508.4
					C687.5,508.4,687.5,508.4,687.5,508.4z"/>
				<path d="M692.2,509.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C692.5,509.3,692.3,509.1,692.2,509.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
</svg>
         </SvgPanZoom>
      </div>
    </div>
  </div>
</template>


<script>
import SvgPanZoom from 'vue-svg-pan-zoom';
import { mapActions } from 'vuex'
import Modal from '@/components/ModalMapas.vue'


export default {
	components: { SvgPanZoom, Modal },

	data () {
		return {
				informacoes: [
							{
                id: 1,
                titulo: 'Barragem Jaguari',
                desc: 'Irrigação e usos multiplos em São Gabriel, Rosário do Sul e Lavras do Sul',
                estagio: 'Obra',
                valor: 'R$ 154,43 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PR-020_Uni_LP.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 2,
                titulo: 'Barragem Taquarembó',
                desc: 'Irrigação e abastecimento humano de Dom Pedrito, Lavras do Sul e Rosário do Sul',
                estagio: 'Obra',
                valor: 'R$ 25,30 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RS-017.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
							},
							{
                id: 3,
                titulo: 'Barragem Arvorezinha',
                desc: 'Abastecimento humano de Bagé',
                estagio: 'Obra',
                valor: 'R$ 96,98 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RS-029.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 4,
                titulo: 'Barragem do rio Itajaí Mirim (Barragem Botuverá)',
                desc: 'Controle de cheias e abastecimento humano dos municípios de Brusque, Guabiruba, Itajaí e Balneário Camboriú',
                estagio: 'Obra',
                valor: 'R$ 102,80 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CC-SC-001.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 5,
                titulo: 'Barragem Miringuava',
                desc: 'Abastecimento humano da Região Metropolitana de Curitiba',
                estagio: 'Obra',
                valor: 'R$ 157,81 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PR-020_Uni_LP.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 6,
                titulo: 'Sistema Adutor Balneário Camboriú-Camboriú (ampliação)',
                desc: 'Abastecimento humano de Balneário Cambriú e Camboriú',
                estagio: 'Anteprojeto',
                valor: 'R$ 76,49 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SC-004.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						  {
                id: 7,
                titulo: 'Sistema Adutor Araquari-Joinville',
                desc: 'Abastecimento humano de Araquari, Balneário Barra do Sul, Joinville e São Francisco do Sul',
                estagio: 'Projeto Básico',
                valor: 'R$ 126,70 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SC-002.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						  {
                id: 8,
                titulo: 'Sistema Adutor Canela-Gramado (ampliação)',
                desc: 'Abastecimento humano de Canela e Gramado',
                estagio: 'EVTEA',
                valor: 'R$ 0,40 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_RS-008.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						  {
                id: 9,
                titulo: 'Sistema Adutor de Pelotas (ampliação)',
                desc: 'Abastecimento humano de Pelotas',
                estagio: 'Obra',
                valor: 'R$ 50,43 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RS-003.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
					 	{
                id: 10,
                titulo: 'Sistema Adutor de Foz do Iguaçu (ampliação)',
                desc: 'Abastecimento humano de Foz do Iguaçu',
                estagio: 'Projeto Básico',
                valor: 'R$ 63,83 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PR-001.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 11,
                titulo: 'Sistema Adutor de Cascavel (ampliação)',
                desc: 'Abastecimento humano de Cascavel',
                estagio: 'Obra',
                valor: 'R$ 76,41 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PR-024.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
							{
                id: 12,
                titulo: 'Sistema Adutor de Porto Alegre (novo manancial)',
                desc: 'Abastecimento humano de Porto Alegre',
                estagio: 'Obra',
                valor: 'R$ 171,69 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PR-024.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 13,
                titulo: 'Sistema Adutor Alvorada-Viamão (ampliação)',
                desc: 'Abastecimento humano de Viamão e Alvorada',
                estagio: 'Obra',
                valor: 'R$ 64,78 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RS-007_Uni_LP.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
							{
                id: 14,
                titulo: 'Sistema Adutor Cubatão-Pilão (ampliação)',
                desc: 'Abastecimento humano de Florianópolis, São José, Palhoça, Biguaçu e Santo Amaro da Imperatriz',
                estagio: 'Obra',
                valor: 'R$ 141,51 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SC-007_Uni_LP.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 15,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Bacias Hidrográficas dos Rios Paranaíba, Grande e Paranapanema',
                desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprim. dos déficits em áreas de baixo grau de segurança hídrica nas bacias dos rios Paranaíba, Grande e Paranapanema',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 1,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacias Paranaiba Grande e Panema.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 16,
                titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
                desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 0,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 17,
                titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Porto Alegre',
                desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Porto Alegre',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 4,80 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Porto Alegre.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 18,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Alta Vulnerabilidade a Inundações – Bacias Hidrográfica dos rios Jacuí e Taquari-Antas',
                desc: 'Definição de alternativas de intervenções para prevenir e mitigar os efeitos das cheias na bacia hidrográfica dos rios Jacuí e Taquari-Antas (RS)',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 6,20 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Cheias-Bacia  Jacui e Taquari-Antas.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 19,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Bacia Hidrográfica do Rio Uruguai',
                desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica na bacia hidrográfica do rio Uruguai',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 1,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacia Uruguai.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 20,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Bacia Hidrográfica do Rio Uruguai',
                desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica na bacia hidrográfica do rio Uruguai',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 1,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacia Uruguai.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 21,
                titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
                desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 0,80 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 22,
                titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Curitiba',
                desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Curitiba',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 4,80 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Curitiba.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 23,
                titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Florianópolis',
                desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Florianópolis',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 3,00 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Florianopolis.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 24,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Alta Vulnerabilidade a Inundações – Bacias Hidrogr. dos rios Tubarão e Araranguá',
                desc: 'Definição de alternativas de intervenções para prevenir e mitigar os efeitos das cheias na bacia hidrográfica dos rios Tubarão e Araranguá (SC)',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 1,50 milhão',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Cheias-Bacia Tubarao-Ararangua.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
						{
                id: 25,
                titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Alta Vulnerabilidade a Inundações – Bacia Hidrográfica do rio Itajaí',
                desc: 'Definição de alternativas de intervenções para prevenir e mitigar os efeitos das cheias na bacia hidrográfica do rio Itajaí (SC)',
                estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
                valor: 'R$ 2,50 milhões',
                icons: null,
                show: true,
                pdf: 'http://arquivos.ana.gov.br/pnsh/TR Cheias-Bacia Itajai.pdf',
                posicao: {
                  top: 20,
                  left: 20,
									right: 0,
									bottom: 0
                },
						},
				]
		}
	},

  methods: {
    ...mapActions({
        showModal: 'Layout/enviarInformacaoModal'
    }),
    mostarIntervencao (item, evt) {

			console.log(item)

      let payload = this.informacoes.filter((value) => {
          return value.id === item
			})

      this.showModal(payload[0]);
    }
  }
}
</script>


<style lang="scss" scoped>

.title-section {
    padding-left: 0px;
    height: 40px;
}

.interacao-intervencao {
	display: flex;
	align-items: center;
    width: 289px;
    @include media_tablet() {
      display: none;
    }
	svg {
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}

	p {
		font-family: 'rubik_italic';
		font-size: 12px;
		line-height: 16px;
	}
}

svg {
    height: 450px;
    width: 100%;
    @media (max-height:  900px) and (min-width: 1200px)   {
        height: 350px;
    }
}
    .st0{fill:#3B6EB6;}
	.st1{fill:#A2DBDF;}
	.st2{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}
	.st3{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}
	.st4{fill:#FFFFFF;}
	.st5{fill:#8FC74B;}
	.st6{fill:#010101;}
</style>
